export default __webpack_public_path__ + "static/media/syster-s.00786149.webp";